import React from "react";
import { ADMIN_URL } from "service/userApi";
import useAdminIframe from "hooks/useAdminIframe";

const Club = () => {
  useAdminIframe("SnsIframe", ADMIN_URL.Club);

  return (
    <div className="flex flex-1 flex-col">
      <iframe id="SnsIframe" title="Club" src="" width="100%" height="100%" className="flex-1" />
    </div>
  );
};

export default Club;
